import { renewTokenEventDispatch } from '@space-events/renewToken'
import { AuthUtils } from '@space-shell/common/utils/auth'

import { MonitoringUtils } from '@space-shell/common/utils/monitoring'

import type { RequestConfig } from './manager'
import { httpManager, whenRequestWithError, whenResponseWithError } from './manager'

const api = httpManager.create({
  baseURL: process.env.BASE_URL,
  headers: {
    'X-Robots-Tag': 'noindex, nofollow'
  }
})

api.interceptors.request.use((request: RequestConfig) => {
  if (AuthUtils.isExpiredToken()) {
    MonitoringUtils.trace({ message: '[AUTH] Expired token' })
    renewTokenEventDispatch()

    return
  }

  return AuthUtils.addTokenToRequest(request)
}, whenRequestWithError)

api.interceptors.response.use((response) => response, whenResponseWithError)

export default api
